import { FC } from 'react';

import NavigationButton from 'components/NavigationButton';

import * as S from './styles';

interface NavigationHeaderProps {
  backTo?: string;
  closeTo?: string;
  onClose?: () => void;
  onBack?: () => void;
}

const NavigationHeader: FC<NavigationHeaderProps> = ({
  backTo,
  closeTo,
  onBack,
  onClose,
}) => {
  return (
    <S.Root>
      {onClose || closeTo ? (
        <NavigationButton onClick={onClose} to={closeTo} variant="close" />
      ) : null}

      <S.CloseButtonContainer>
        {onBack || backTo ? (
          <NavigationButton onClick={onBack} to={backTo} variant="back" />
        ) : null}
      </S.CloseButtonContainer>
    </S.Root>
  );
};

export default NavigationHeader;
